import React from 'react';
import styles from './CSRSection.module.css';

const CSRSection = ({ showHealthText = false }) => {
    return (
        <section className={styles.csrSection}>
            <div className={styles.container}>
                {/* Main CSR Heading */}
                <div className={styles.csrHeader}>
                    <h1 className={styles.csrTitle}>
                        <span className={styles.titleBlue}>Corporate Social</span>{' '}
                        <span className={styles.titleDark}>Responsibility</span>
                    </h1>
                    
                    <p className={styles.csrDescription}>
                        Corporate Social Responsibility (CSR) is a vital component of PISCESIA Power Transmission's culture and a way of contributing to the society. 
                        Given our transformative impact on power infrastructure and industrial development, our CSR activities focus on issues related to community 
                        welfare, environmental sustainability, education, health, and supporting underprivileged communities.{showHealthText && ' Additionally, be of help to them to improve their health conditions.'}
                    </p>
                </div>

                {/* Partnership Section */}
                <div className={styles.partnershipSection}>
                    <div className={styles.partnershipContent}>
                        <div className={styles.partnershipLeft}>
                            <h2 className={styles.partnershipTitle}>
                                Partnership program with Manav Kalyan Foundation
                            </h2>
                            
                            <p className={styles.partnershipDescription}>
                                Our partnership with Manav Kalyan Foundation brings together 
                                our resources, expertise, and commitment to social 
                                responsibility. Together, we are implementing a range of 
                                initiatives aimed at ensuring that no one goes to bed hungry.
                            </p>
                        </div>
                        
                        <div className={styles.partnershipCenter}>
                            <div className={styles.illustrationContainer}>
                                <svg viewBox="0 0 400 300" className={styles.partnershipIllustration}>
                                    {/* Table */}
                                    <ellipse cx="200" cy="240" rx="120" ry="25" fill="#f3f4f6" />
                                    
                                    {/* Papers on table */}
                                    <rect x="150" y="220" width="40" height="30" rx="2" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1"/>
                                    <rect x="210" y="215" width="45" height="35" rx="2" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1"/>
                                    <line x1="155" y1="225" x2="185" y2="225" stroke="#d1d5db" strokeWidth="1"/>
                                    <line x1="155" y1="230" x2="180" y2="230" stroke="#d1d5db" strokeWidth="1"/>
                                    <line x1="155" y1="235" x2="185" y2="235" stroke="#d1d5db" strokeWidth="1"/>
                                    
                                    {/* Coffee cups */}
                                    <circle cx="270" cy="230" r="8" fill="#8b4513" />
                                    <circle cx="270" cy="230" r="6" fill="#d2691e" />
                                    <circle cx="130" cy="235" r="7" fill="#8b4513" />
                                    <circle cx="130" cy="235" r="5" fill="#d2691e" />
                                    
                                    {/* Person 1 (Left - wearing suit) */}
                                    <g transform="translate(120, 80)">
                                        {/* Body */}
                                        <rect x="15" y="80" width="50" height="100" rx="10" fill="#1f2937" />
                                        <rect x="20" y="85" width="40" height="90" rx="5" fill="#374151" />
                                        {/* Tie */}
                                        <rect x="32" y="85" width="16" height="60" rx="2" fill="#ef4444" />
                                        
                                        {/* Arms */}
                                        <rect x="5" y="90" width="15" height="60" rx="7" fill="#1f2937" />
                                        <rect x="60" y="90" width="15" height="60" rx="7" fill="#1f2937" />
                                        
                                        {/* Head */}
                                        <circle cx="40" cy="40" r="25" fill="#60a5fa" />
                                        
                                        {/* Hair */}
                                        <path d="M 20 25 Q 40 10 60 25 L 55 35 Q 40 20 25 35 Z" fill="#1f2937" />
                                        
                                        {/* Beard */}
                                        <path d="M 25 45 Q 40 60 55 45 Q 50 55 40 58 Q 30 55 25 45" fill="#1f2937" />
                                        
                                        {/* Eyes */}
                                        <circle cx="32" cy="38" r="2" fill="#1f2937" />
                                        <circle cx="48" cy="38" r="2" fill="#1f2937" />
                                        
                                        {/* Hand reaching across */}
                                        <circle cx="85" cy="120" r="8" fill="#60a5fa" />
                                    </g>
                                    
                                    {/* Person 2 (Right - casual shirt) */}
                                    <g transform="translate(240, 80)">
                                        {/* Body */}
                                        <rect x="15" y="80" width="50" height="100" rx="10" fill="#f9fafb" />
                                        <rect x="20" y="85" width="40" height="90" rx="5" fill="#ffffff" />
                                        
                                        {/* Shirt details */}
                                        <line x1="40" y1="85" x2="40" y2="170" stroke="#e5e7eb" strokeWidth="1"/>
                                        <circle cx="35" cy="100" r="1.5" fill="#6b7280" />
                                        <circle cx="35" cy="115" r="1.5" fill="#6b7280" />
                                        <circle cx="35" cy="130" r="1.5" fill="#6b7280" />
                                        
                                        {/* Arms */}
                                        <rect x="5" y="90" width="15" height="60" rx="7" fill="#f9fafb" />
                                        <rect x="60" y="90" width="15" height="60" rx="7" fill="#f9fafb" />
                                        
                                        {/* Head */}
                                        <circle cx="40" cy="40" r="25" fill="#60a5fa" />
                                        
                                        {/* Hair */}
                                        <path d="M 20 25 Q 40 15 60 25 L 55 35 Q 40 25 25 35 Z" fill="#8b4513" />
                                        
                                        {/* Glasses */}
                                        <circle cx="32" cy="38" r="8" fill="none" stroke="#374151" strokeWidth="1.5" />
                                        <circle cx="48" cy="38" r="8" fill="none" stroke="#374151" strokeWidth="1.5" />
                                        <line x1="40" y1="38" x2="40" y2="38" stroke="#374151" strokeWidth="1.5"/>
                                        
                                        {/* Eyes */}
                                        <circle cx="32" cy="38" r="2" fill="#1f2937" />
                                        <circle cx="48" cy="38" r="2" fill="#1f2937" />
                                        
                                        {/* Hand reaching across */}
                                        <circle cx="-5" cy="120" r="8" fill="#60a5fa" />
                                    </g>
                                    
                                    {/* Handshake */}
                                    <ellipse cx="200" cy="200" rx="15" ry="8" fill="#60a5fa" />
                                    <rect x="185" y="196" width="30" height="8" rx="4" fill="#60a5fa" />
                                </svg>
                            </div>
                        </div>
                        
                        <div className={styles.partnershipRight}>
                            <div className={styles.objectiveSection}>
                                <div className={styles.objectiveLabel}>OBJECTIVE</div>
                                <div className={styles.objectiveTitle}>Food for everyone</div>
                                
                                <div className={styles.foodIconContainer}>
                                    <svg viewBox="0 0 120 120" className={styles.foodIcon}>
                                        {/* Plate */}
                                        <circle cx="60" cy="80" r="35" fill="none" stroke="#1f2937" strokeWidth="2" />
                                        <circle cx="60" cy="80" r="30" fill="none" stroke="#1f2937" strokeWidth="1" />
                                        
                                        {/* Food items on plate */}
                                        <circle cx="50" cy="75" r="4" fill="#ef4444" />
                                        <circle cx="65" cy="72" r="3" fill="#3b82f6" />
                                        <circle cx="55" cy="85" r="3.5" fill="#3b82f6" />
                                        <circle cx="70" cy="85" r="3" fill="#8b5cf6" />
                                        <circle cx="45" cy="85" r="2.5" fill="#06b6d4" />
                                        
                                        {/* Rice/grain pattern */}
                                        <g fill="#60a5fa">
                                            <circle cx="58" cy="78" r="1" />
                                            <circle cx="62" cy="80" r="1" />
                                            <circle cx="56" cy="82" r="1" />
                                            <circle cx="64" cy="76" r="1" />
                                            <circle cx="52" cy="80" r="1" />
                                            <circle cx="67" cy="78" r="1" />
                                        </g>
                                        
                                        {/* Fork */}
                                        <g stroke="#1f2937" strokeWidth="1.5" fill="none">
                                            <line x1="20" y1="45" x2="20" y2="65" />
                                            <line x1="18" y1="45" x2="18" y2="50" />
                                            <line x1="22" y1="45" x2="22" y2="50" />
                                            <line x1="16" y1="45" x2="16" y2="48" />
                                            <line x1="24" y1="45" x2="24" y2="48" />
                                        </g>
                                        
                                        {/* Spoon */}
                                        <g stroke="#1f2937" strokeWidth="1.5" fill="none">
                                            <line x1="100" y1="45" x2="100" y2="65" />
                                            <ellipse cx="100" cy="50" rx="3" ry="5" />
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CSRSection;
